export enum HandednessFilters {
  All = "ALL",
  Right = "R",
  Left = "L",
}
